var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('bo-navbar'),_c('div',{staticClass:"page-content"},[_c('bo-sidebar'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }